import React from 'react';

const ProfileSidebar = ({ information, activeSection, onSectionChange }) => {
  const menuItems = [
    { id: 'public-profile', label: 'Ver perfil público'},
    { id: 'my-profile', label: 'Mi perfil'},
    { id: 'photography', label: 'Fotografía'},
    { id: 'security', label: 'Seguridad de la cuenta'},
    { id: 'privacy', label: 'Privacidad'},
  ];

  return (
    <div className="w-full md:w-1/3 flex flex-col items-center border-r border-gray-200 p-6 bg-gray-50">
      {information.find((item) => item.id === 1) && (
        <div className="flex flex-col items-center space-y-2 mb-8">
          <h2 className="font-bold text-lg text-gray-800 text-center">
            {information.find((item) => item.id === 1).title}
          </h2>
        </div>
      )}

      <div className="w-full">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => onSectionChange(item.id)}
                className={`w-full text-left p-3 rounded-lg transition-all duration-200 flex items-center space-x-3 ${
                  activeSection === item.id
                    ? 'bg-teal-500 text-white shadow-md'
                    : 'text-gray-600 hover:bg-gray-100 hover:text-teal-600'
                }`}
              >
                <span className="text-lg">{item.icon}</span>
                <span className="font-medium">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProfileSidebar;